import classes from './ChatWidget.module.scss'
import { getProductCompanyBadge } from './productCompany'
import { ChatBrand } from './types'

interface Props {
  brands: ChatBrand[]
}

/** Marka kataloğunu marka ve portal şirketi logolarıyla salt-okuma kartlar halinde gösterir. */
export default function BrandCards({ brands }: Props) {
  if (brands.length === 0) return null

  return (
    <div className={classes.brandCatalog} role='list' aria-label='Markalar'>
      {brands.map((brand, index) => (
        <article key={`${brand.id ?? brand.name}-${index}`} className={classes.brandCard} role='listitem'>
          <div className={classes.brandLogo}>
            {brand.imageUrl ? (
              <img src={brand.imageUrl} alt='' loading='lazy' decoding='async' />
            ) : (
              <span aria-hidden='true'>{brand.name.slice(0, 2).toLocaleUpperCase('tr-TR')}</span>
            )}
          </div>

          <div className={classes.brandContent}>
            <strong className={classes.brandName}>{brand.name}</strong>
            <div className={classes.brandCompanies} aria-label={`${brand.name} şirketleri`}>
              {brand.companies.map((company, companyIndex) => {
                const numericCompanyCode = company.code ? Number(company.code) : null
                const companyBadge =
                  getProductCompanyBadge(company.id) ??
                  getProductCompanyBadge(
                    numericCompanyCode !== null && Number.isFinite(numericCompanyCode) ? numericCompanyCode : null
                  )

                if (!companyBadge) return null

                return (
                  <span
                    key={`${company.id ?? company.code ?? company.name}-${companyIndex}`}
                    className={classes.brandCompany}
                    title={companyBadge.name}
                  >
                    <img
                      src={companyBadge.logoSrc}
                      alt={`${companyBadge.name} şirketi`}
                      loading='lazy'
                      decoding='async'
                    />
                  </span>
                )
              })}
            </div>
          </div>
        </article>
      ))}
    </div>
  )
}
